import React from 'react';
import CardLogin from 'app/components/Layouts/CardLogin';
import { Box, Button, OutlinedInput, Typography } from '@mui/material';
import { inputInfo, infoText, descText, btnBox, warningBox, errorText } from './Recovery.sx';
import BackButton from 'app/components/BackButton';
import useRecovery from 'app/pages/Authorization/Recovery/useRecovery';
import WarningIcon from 'app/components/Icons/WarningIcon';

function Recovery() {
  const { t, emailInput, isLoadingRecovery, dataRecovery, register, handleChangeEmail, handleSubmitForm } =
    useRecovery();

  return (
    <CardLogin>
      <Typography sx={infoText}>{t('recovery.recoveryPass')}</Typography>
      <Typography sx={descText}>{t('recovery.description')}</Typography>
      <form
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        onSubmit={handleSubmitForm}
      >
        <Box>
          <Typography sx={inputInfo}>Email</Typography>
          <OutlinedInput
            type={'email'}
            placeholder={t('recovery.email')}
            value={emailInput}
            sx={{
              width: '100%',
              mb: '24px',
              pl: '16px',
              '@media screen and (max-height: 864px)': {
                mb: '20px',
              },
            }}
            inputProps={{
              style: { paddingLeft: '0' },
            }}
            onChange={handleChangeEmail}
          />
        </Box>
        {dataRecovery?.error && (
          <Box sx={warningBox}>
            <WarningIcon sx={{ mr: '16px' }} />
            <Typography sx={errorText}>{dataRecovery?.error && dataRecovery?.error.text}</Typography>
          </Box>
        )}

        <Box sx={btnBox}>
          <Button
            type={'submit'}
            disabled={!(emailInput.length > 0) || isLoadingRecovery}
            variant={'contained'}
            sx={{ mb: '12px' }}
          >
            {t('recovery.continue')}
          </Button>
          <BackButton text={'recovery.back'} />
        </Box>
      </form>
    </CardLogin>
  );
}

export default Recovery;
